// src/components/DataTable.jsx
import React from 'react';

export default function DataTable({ columns, data, onEdit, onDelete, idKey = 'id' }) {
  if (!data || data.length === 0) {
    return <div class="no-records">No records found.</div>;
  }

  return (
    <div class="table-wrapper">
      <table class="data-table">
        <thead>
          <tr class="table-header-row">
            {columns.map((col) => (
              <th key={col.key} class="table-header-cell">
                {col.label}
              </th>
            ))}
            <th class="table-header-cell table-header-actions">Actions</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row) => (
            <tr key={row[idKey]} class="table-body-row">
              {columns.map((col) => (
                <td key={col.key} class="table-body-cell">
                  {col.render ? col.render(row[col.key], row) : String(row[col.key] ?? '')}
                </td>
              ))}
              <td class="table-body-cell table-body-actions">
                <button onClick={() => onEdit(row)} class="btn-action-edit">Edit</button>
                <button onClick={() => onDelete(row[idKey])} class="btn-action-delete">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}